import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import { useUser } from "../context/useUser";
import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../utils/imageUrl";

export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [loading, setLoading] = useState(true);
  const { user, selectedCompany } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchProduct() {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_CONNECTION}/form/product/${id}`, {
          headers: { Authorization: `Bearer ${user.token}` },
        });
        if (!res.ok) throw new Error("Product not found");
        const data = await res.json();
        setProduct(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    fetchProduct();
  }, [id]);
  
  useEffect(() => {
    if (!selectedCompany?.summaryId) return;

    async function checkSelection() {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_CONNECTION}/form/summary/${selectedCompany.summaryId}/selections`, {
          headers: { Authorization: `Bearer ${user.token}` }
        });

      const selections = await res.json();

      console.log("SELECTIONS:", selections);

      if (!Array.isArray(selections)) return;

      const productSelected = selections.some(s =>
        s.item_type === "product" && Number(s.product_id) === Number(id)
      );

      setIsSelected(productSelected);
    }

    checkSelection();
  }, [id, selectedCompany, user]);

  if (loading) return <p>Loading...</p>;
  if (!product) return <p>Product not found</p>;

  const size =
  product.height && product.width && product.depth
    ? `${product.width} × ${product.depth} × ${product.height} cm`
    : null;

  const techSpecs = [
    { label: "Mitat", value: size },
    { label: "Materiaali", value: product.material },
    { label: "Väri", value: product.color },
    { label: "Valmistaja", value: product.manufacturer },
    { label: "Tuotekoodi", value: product.product_code },
    { label: "Valmistajan koodi", value: product.manufacturers_code },
  ].filter(spec => spec.value);

  return (
    <div>
      <Header />
      <div className="product-page-content">
        <button 
          className="product-back-btn"
          onClick={() => navigate(-1)}>
          <i className="fa-solid fa-arrow-left"></i>
          Takaisin
        </button>

        <img
          className="product-page-image"
          src={getImageUrl(product.main_image)}
          alt={product.name}
          //onError={(e) => (e.currentTarget.src = "")}
        />

        <div className="product-page-info">
        <div className="product-brand-row">
          <div className="product-brand-badge">
            {product.manufacturer}
          </div>

          {product.link_to_manufacturer && (
            <a
              href={product.link_to_manufacturer}
              target="_blank"
              rel="noopener noreferrer"
              className="product-manufacturer-link"
              title="Valmistajan sivu"
            >
              <i className="fa-solid fa-link"></i>
            </a>
          )}
        </div>

        <h1 className="product-page-title">{product.name}</h1>

        <p className="product-page-subtitle">{product.descriptive_name}</p>

        <div className="default-text">
          <p>{product.short_description}. Suscipit gravida risus sit amet pellentesque. Nulla
            luctus sagittis felis, eget mollis elit sollicitudin in. Donec at fermentum urna.
          </p>
          <p><strong>Tyyli:</strong> {product.style}</p>
          <p><strong>Tuotekoodi:</strong> {product.product_code}</p>
        </div>

        <button className={`btn product-select-btn ${isSelected ? "selected" : ""}`}>
          {isSelected ? "VALITTU" : "VALITSE"}</button>
        </div>
        </div>

        <div className="product-tech-specs">
          <div className="image-row">
            <img
              className="product-page-image"
              src={getImageUrl(product.environment_image)}
              alt={product.name}
              //onError={(e) => (e.currentTarget.src = "https://via.placeholder.com/400x300")}
            />

            <img
              className="product-page-image"
              src={getImageUrl(product.technical_image)}
              alt={product.name}
              //onError={(e) => (e.currentTarget.src = "https://via.placeholder.com/400x300")}
            />
          </div>

          <p className="default-text section-text">{product.long_description}. Suscipit gravida risus sit amet pellentesque. Nulla
            luctus sagittis felis, eget mollis elit sollicitudin in. Donec at fermentum urna.
          </p>
          <p className="product-page-title">Tekniset tiedot</p>
          <div className="tech-specs-content default-text">
            {techSpecs.map(({ label, value }) => (
              <p key={label}>
                <strong>{label}</strong> {value}
              </p>
            ))}
          </div>
        </div>
      <Footer />
    </div>
  );
}
